import { render, staticRenderFns } from "./VoteButtonList.vue?vue&type=template&id=63d6342e&scoped=true&"
import script from "./VoteButtonList.vue?vue&type=script&lang=ts&"
export * from "./VoteButtonList.vue?vue&type=script&lang=ts&"
import style0 from "./VoteButtonList.vue?vue&type=style&index=0&id=63d6342e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6342e",
  null
  
)

export default component.exports